import { render, staticRenderFns } from "./InvitationCode.vue?vue&type=template&id=6beaca83&scoped=true"
import script from "./InvitationCode.vue?vue&type=script&lang=js"
export * from "./InvitationCode.vue?vue&type=script&lang=js"
import style0 from "./InvitationCode.vue?vue&type=style&index=0&id=6beaca83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beaca83",
  null
  
)

export default component.exports